// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2gf3Z","additionalInfo":"AgreementModal_additionalInfo__1FNWU"};